export const SYSTEM_TYPES = {
  PJN: 'pjn',
  MEV: 'mev',
  EJE: 'eje',
  COPREC: 'coprec',
  INPI: 'inpi'
};

export const SYSTEM_LABELS = {
  [SYSTEM_TYPES.PJN]: 'PJN',
  [SYSTEM_TYPES.MEV]: 'MEV',
  [SYSTEM_TYPES.EJE]: 'EJE',
  [SYSTEM_TYPES.COPREC]: 'COPREC',
  [SYSTEM_TYPES.INPI]: 'INPI'
};
